import moment from 'moment';
import { Fragment } from 'react';
import { Toast } from 'antd-mobile'; 
import ToastShow from '@components/ToastShow';
import {
    WebUrl,
    ImgBaseUrl,
    ChannelCacheKey,
    GoogleGclid,
    GoogleGclidCreationTime,
    GoogleKeyword,
    GoogleMatchType,
    BingMsclkid,
    BingMsclkidCreationTime,
    BingKeyWord,
    BingQuery,
    AuthCacheKey,
    LangCacheKey,
} from '@common/config';

export const getFromLocalStorage = key => {
    return localStorage.getItem(key);
};

export const isString = s => typeof s === 'string';

export const isNumber = n => typeof n === 'number';

export const isObject = o => typeof o === 'object';

export const setToLocalStorage = (key, value) => {
    localStorage.setItem(key, isString(value) ? value : JSON.stringify(value));
};

export const removeFromLocalStorage = key => {
    localStorage.removeItem(key);
};

export const stopPropagation = e => {
    e.stopPropagation();
};
export const getLangType = () => {
    const lang = getFromLocalStorage(LangCacheKey);
    if (lang === 'fr') {
        return 'fr_FR';
    } else if (lang === 'es') {
        return 'es_ES';
    } else if (lang === 'Deutsch') {
        return 'de_DE';
    } else if (lang === 'Português') {
        return 'pt_PT';
    } else {
        return 'en_US';
    }
};
export const parseQueryString = query => {
    const ret = Object.create(null);
    if (query) {
        query
            .substring(1)
            .split('&')
            .forEach(pair => {
                const [k, v] = pair.split('=');
                ret[k] = decodeURIComponent(v);
            });
    }
    return ret;
};

export const stringifyQuery = query => {
    if (!query) {
        return '';
    }
    const keys = Object.keys(query);
    if (!keys.length) {
        return '';
    }
    const ret = [];
    keys.forEach(k => {
        ret.push(`${k}=${encodeURIComponent(query[k])}`);
    });
    return '?' + ret.join('&');
};

export const getImgUrl = url => {
    if (!url || url.startsWith('http') || url.startsWith('//')) {
        return url;
    }
    return ImgBaseUrl + (url.startsWith('/') ? '' : '/') + url;
};

export const getMessageTimeTxt = ms => {
    const today = moment().startOf('day').valueOf();
    return ms < today
        ? moment(ms).format('YYYY-MM-DD hh:mmA')
        : moment(ms).format('hh:mmA');
};

export const getFormattedTime = ms => {
    return moment(ms).format('YYYY-MM-DD HH:mm');
};

export const parseTimeDuration = seconds => {
    if (!seconds) {
        return '00:00';
    }
    let s = seconds % 60;
    let m = Math.floor(seconds / 60);
    return `${(m + '').padStart(2, '0')}:${(s + '').padStart(2, '0')}`;
};

export const getRandomFromArray = array => {
    return array[Math.floor(Math.random() * array.length)];
};

export const parseToAbsUrl = url => {
    if (!url) {
        return '';
    }
    if (url.startsWith('http') || url.startsWith('/')) {
        return url;
    }
    return '//' + url;
};

// const LevelName = ['Acquaintance', 'Acquaintance', 'Friend', 'Close Friend', 'Confidant']

export const getLevelName = (config, level) => {
    if (!Array.isArray(config)) {
        return '';
    }
    const l = config.find(c => c.level === level);
    if (l) {
        return l.levelDesc;
    }
    return '';
};

export const getDayStart = () => {
    return moment().startOf('day').valueOf();
};

export const safeParse = (str, defaultValue = {}) => {
    if (!isString(str) || !str.length) {
        return defaultValue;
    }
    try {
        return JSON.parse(str);
    } catch (e) {
        console.error(e, str);
        return defaultValue;
    }
};

export const throttle = (fn, interval = 333) => {
    let timerId;

    return function () {
        if (!timerId) {
            const args = arguments;
            timerId = setTimeout(() => {
                fn.apply(this, args);
                timerId = null;
            }, interval);
        }
    };
};

const toFixed2 = str => {
    const index = str.indexOf('.');
    if (index < 0) {
        return str;
    }
    if (str.charAt(index + 1) === '0') {
        return str.substring(0, index);
    }
    if (str.charAt(index + 2) === '0') {
        return str.substring(0, index + 2);
    }
    return str.substring(0, index + 3);
};

export const showHeat = heat => {
    if (heat > 9999) {
        const str = heat / 10000 + '';
        return toFixed2(str) + 'w';
    }
    if (heat > 999) {
        const str = heat / 1000 + '';
        return toFixed2(str) + 'k';
    }
    return heat + '';
};

export const showHot = heat => {
    if (heat > 999999) {
        const str = heat / 1000000 + '';
        return toFixed2(str) + 'm';
    }
    if (heat > 999) {
        const str = heat / 1000 + '';
        return toFixed2(str) + 'k';
    }
    return heat + '';
};


export const showHotUppercase = heat => {
    if (heat > 999999) {
        const str = heat / 1000000 + '';
        return toFixed2(str) + 'M';
    }
    if (heat > 999) {
        const str = heat / 1000 + '';
        return toFixed2(str) + 'K';
    }
    return heat + '';
};

export const getTransferParams = () => {
    const keyMap = {
        pid: ChannelCacheKey,
        gclid: GoogleGclid,
        gclid_creationTime: GoogleGclidCreationTime,
        ggkeyword: GoogleKeyword,
        ggmatchtype: GoogleMatchType,
        msclkid: BingMsclkid,
        msclkid_creationTime: BingMsclkidCreationTime,
        bingkeyword: BingKeyWord,
        bingquery: BingQuery,
    };
    let params = [];
    Object.keys(keyMap)?.forEach(key => {
        const value =
            getFromLocalStorage(keyMap[key]) || getFromSessionStorage(keyMap[key]);
        if (value?.length) {
            params.push(`${key}=${value}`);
        }
    });
    return params.join('&');
};

export const getWebUrl = url => {
    const params = getTransferParams();
    if (!url || !url?.length) {
        return `${WebUrl}?${params}`;
    }
    if (url.includes('?')) {
        url = `${url}&${params}`;
    } else {
        url = `${url}?${params}`;
    }
    if (url.startsWith('http') || url.startsWith('//')) {
        return url;
    } else {
        return WebUrl + (url.startsWith('/') ? '' : '/') + url;
    }
};

/**
 * 字符串模版渲染处理
 * @param {*} str
 * @returns
 */
export const strTemplateRender = str => {
    if (!str?.length) return '';
    const arr = str?.split('\n');
    return arr?.map((item, index) => (
        <Fragment key={`${item}-${index}`}>
            {item}
            {index !== arr.length - 1 && <br />}
        </Fragment>
    ));
};

/**
 * 获取URL查询参数
 * @param {string} [param] - 要获取的特定参数名
 * @returns {string|Object|null} - 参数值或所有参数对象
 */
export const getQueryParams = param => {
    const params = new URLSearchParams(window.location.search);

    if (!param) {
        return Object.fromEntries(params.entries());
    }

    return params.get(param);
};

export function isEmptyObject(obj) {
    if (obj === null) {
        return true;
    }
    return Object.keys(obj).length === 0;
}

export const getFromSessionStorage = key => {
    return sessionStorage.getItem(key);
};

export const setToSessionStorage = (key, value) => {
    sessionStorage.setItem(key, isString(value) ? value : JSON.stringify(value));
};

export const getPageName = pathname => {
    const str = pathname.substring(1);
    if (!str) {
        return 'explore';
    }
    const split = str.indexOf('/');
    return split > 0 ? str.substring(0, split) : str;
};

// 过滤对象中为null/undefined/''/[]/{}的属性值
export const clearEmptyDeep = obj => {
    if (!obj || !typeof obj === 'object') return;
    const keys = Object.keys(obj);
    for (var key of keys) {
        const val = obj[key];
        if (
            typeof val === 'undefined' ||
            ((typeof val === 'object' || typeof val === 'string') && !val)
        ) {
            delete obj[key];
        } else if (typeof val === 'object') {
            clearEmptyDeep(obj[key]);
            if (Object.keys(obj[key]).length === 0) {
                delete obj[key];
            }
        }
    }
};

let navigate = null;

export const setNavigate = nav => {
    navigate = nav;
};

export const getNavigate = () => {
    return navigate;
};

export const isLogin = () => {
    const token = getFromLocalStorage(AuthCacheKey);
    if (token) {
        return true;
    } else {
        navigate?.('/login');
        return false;
    }
};

export const isIOS = () => {
    const ua = window.navigator.userAgent;
    return /iPad|iPhone|iPod/.test(ua);
};

export const dataFormat = (timestamp, rule = 'YYYY-MM-DD HH:mm:ss') => {
    if (timestamp) {
        return moment(timestamp).format(rule);
    } else {
        return '-';
    }
};

export const dataFormatUs = timestamp => {
    if (timestamp) {
        const date = new Date(timestamp);

        // 输出: "Oct 11, 2025"
        const formattedDate = date.toLocaleDateString('en-US', {
            month: 'short', // "Oct"
            day: 'numeric', // "11"
            year: 'numeric', // "2025"
        });
        return formattedDate;
    } else {
        return '-';
    }
};

export const downloadFile = (url, filename) => {
    if (!url?.length) return;
    const link = document.createElement('a');
    link.href = url;
    link.download = filename || 'xpose.png';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const isDev = () => {
    const host = window.location.hostname;
    if (
        host.indexOf('localhost') > -1 ||
        host.indexOf('127.0.0.1') > -1 ||
        host.indexOf('test') > -1
    ) {
        return true;
    }
    return false;
};
export const isImage = url => {
    const pattern = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i;
    return pattern.test(url);
};

export const classNames = (...args) => {
    function merge(...args) {
        const len = args.length;
        let classnames = [];
        for (let i = 0; i < len; i++) {
            const n = args[i];
            if (n != null && !!n) {
                if (typeof n === 'string' || typeof n === 'number') {
                    classnames.push(n);
                } else if (typeof n === 'object') {
                    if (Array.isArray(n)) {
                        n.forEach(_n => {
                            if (typeof _n === 'object') {
                                classnames.push(...merge(_n));
                            } else {
                                classnames.push(_n);
                            }
                        });
                    } else {
                        const ns = Object.keys(n).filter(_n => !!n[_n] && _n);
                        classnames.push(...ns);
                    }
                }
            }
        }
        return classnames;
    }

    const classnames = [...new Set([...merge(...args)])];
    return classnames.length ? classnames.join(' ') : '';
};

export const px2rem = str => {
    if (/%/gi.test(str)) {
        return str;
    } else {
        return parseFloat(str) / 37.5 + 'rem';
    }
};

// 深拷贝（处理循环引用）
export const deepCopyObj = (() => {
    const isObject = obj => {
        return typeof obj === "object" && obj !== null;
    };

    // 使用 WeakMap 存储已拷贝的对象，解决循环引用问题
    return function deepCopy(obj, hash = new WeakMap()) {
        // 基本类型直接返回
        if (!isObject(obj)) return obj;

        // 检查是否已拷贝过（解决循环引用）
        if (hash.has(obj)) return hash.get(obj);

        // 处理特殊对象
        if (obj instanceof Date) return new Date(obj);
        if (obj instanceof RegExp) return new RegExp(obj);
        if (obj instanceof Map) return new Map(Array.from(obj.entries()));
        if (obj instanceof Set) return new Set(Array.from(obj.values()));
        if (obj instanceof Error) return Object.create(obj);

        // 处理 null
        if (obj === null) return null;

        // 获取对象的原型
        let res = Array.isArray(obj) ? [] : {};
        Object.setPrototypeOf(res, Object.getPrototypeOf(obj));

        // 记录到 hash 表
        hash.set(obj, res);

        // 处理 Symbol 类型的键
        const allKeys = [
            ...Object.getOwnPropertyNames(obj),
            ...Object.getOwnPropertySymbols(obj)
        ];

        for (let key of allKeys) {
            if (isObject(obj[key])) {
                res[key] = deepCopy(obj[key], hash);
            } else {
                res[key] = obj[key];
            }
        }

        return res;
    };
})();

export const copyFunc = (url,istranslate = false,text = 'copy success') => {
    const textArea = document.createElement('textarea');
    textArea.value = url;
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        const successful = document.execCommand('copy');
        if (successful) {
            ToastShow.specialInfo(istranslate ? text : 'copy success');
        } else {
            ToastShow.info('copy failed');
        }
    } catch (err) {
        Toast.show('copy failed');
    }
    document.body.removeChild(textArea);
}


//将数字9999转换为9,999
export const formatNumToCurrency = (num) => {
    if(!num || typeof num !== 'number') return null;
    const LESSLEN = 3; //最小格式化长度
    const strNum = String(num);
    const strLen = strNum.length;
    if(strLen <= LESSLEN || strNum.includes('.')) return num; //小数点不处理
    const startSplitPos = strLen % LESSLEN;
    const splitCount = Math.floor((strLen - startSplitPos) / 3);
    let formatNums = [];
    for(let i = 0; i < splitCount; i++){
        formatNums.push(strNum.slice(startSplitPos + (i * LESSLEN),  startSplitPos + (i + 1) * LESSLEN));
    }
    if(startSplitPos > 0){
        return strNum.slice(0, startSplitPos) + ',' + formatNums.join(',');
    }
    return formatNums.join(',');
}
export const isEmpty = (obj) => {
  if (obj == null) return true;
  return Object.keys(obj).length === 0;
}

export const openAppType = (type) =>{
    // if (isIOS()) {
    //     window.location.href = `sallochat://main?type=${type}`;
    // } else {
    //     window.location.href = `sallochat://main?type=${type}`;
    // }
    window.location.href = `sallochat://main?type=${type}`;
}